import { colors, fontSizes } from '../../../../Components/consts'
import { styled } from '@mui/system'

type ProgressProps = {
  total: number
  filled?: boolean
}

type ThemeProps = {
  uiTheme: 'light' | 'dark'
}

export const ProgressBarStyle = styled('div')<ProgressProps>(({ total, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  margin: theme.spacing(0, 1),
}))

export const BarItemCon = styled('div')<ProgressProps>(({ filled, total, theme }) => ({
  margin: theme.spacing(1, 0.5),
  width: `calc(100% / ${total})`,
  height: 5,
  borderRadius: 5,
  backgroundColor: filled ? colors.yellow : colors.gray.gray20,
}))

export const TopRowCon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0.5),
  },
  '& .groupTitle': {
    textAlign: 'center',
    fontSize: fontSizes.xlarge,
    fontWeight: 'bold',
    margin: theme.spacing(4, 2, 8),
    color: colors.text,
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.small,
      margin: theme.spacing(2),
    },
   }
}))

export const PickResultsCon = styled('div')<ThemeProps>(({ uiTheme, theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  '& .title': {
    fontSize: fontSizes.medium,
    color: uiTheme === 'dark' ? colors.gray.gray20 : colors.gray.gray80,
    marginRight: 5,
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.xSmall,
    },
  },
  '& .actual': {
    fontSize: fontSizes.medium,
    color: colors.yellow,
    fontWeight: 800,
    marginRight: 5,
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.small,
    },
  },
  '& .total': {
    fontSize: fontSizes.medium,
    color: uiTheme === 'dark' ? colors.gray.gray20 : colors.gray.gray80,
    fontWeight: 800,
    marginRight: 5,
    [theme.breakpoints.down('md')]: {
      fontSize: fontSizes.small,
    },
  },
}))
